module.exports = __webpack_public_path__ + "img/shop-ball-income-icon.5290907a.png";